module.exports = __webpack_public_path__ + "static/img/mobile_remote_guidance.b75da113.png";